import { Select2ServiceCenter } from '~/components/Select2ServiceCenter';
import { Select2ServiceCenterMember } from '~/components/Select2ServiceCenterMember';
import loc from 'Templates/4tservice/components/service/request.new/.default/lang/ru.json';
import { isNil, not, compose } from 'ramda';
import { Can } from '@casl/vue';

const lang = (key) => loc[`s.r.n_${key}`];
const notNil = compose(not, isNil);

export default {
	name: 'ServiceRequestnewFormService',
	props: {
		initialService: Object,
		initialResponsible: Object,
	},
	data: (vm) => ({
		serviceId: vm.initialService?.id || null,
		responsibleId: vm.initialResponsible?.id || null,
	}),
	watch: {
		serviceId: function() {
			this.responsibleId = null;
		},
	},
	render() {
		return (
			<div>
				<Can I="update" a="ServiceRequest" field="SERVICE_ID">
					<Select2ServiceCenter
						class="mb-6"
						name="SERVICE_ID"
						required
						label={ lang('SERVICE_CENTER') }
						error-message="Выберите сервисный центр"
						value={ this.serviceId }
						vOn:select={ (data) => this.serviceId = data?.id }
					/>
					{ notNil(this.serviceId) ? (
						<Select2ServiceCenterMember
							class="mb-0"
							name="RESPONSIBLE"
							label={ lang('RESPONSIBLE_MEMBER') }
							required
							value={ this.responsibleId }
							serviceId={ this.serviceId }
							error-message="Выберите ответственного за заявку"
							vOn:select={ (data) => this.responsibleId = data?.id }
						/>
					) : null }
				</Can>
			</div>
		);
	}
}
